<section class="home-slider">
  <div class="swiper-container swiper-home-slide">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide" style="background-image: url(assets/images/2.jpg);">
        <div class="swiper-slide-caption header-transparent-slide-caption">
        </div>
      </div> -->
      <div class="breadcrumb-bottom-img">
        <img
          src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
        />
      </div>
      <div
        class="swiper-slide"
        style="background-image: url(assets/images/3.JPG)"
      >
        <div
          class="swiper-slide-caption header-transparent-slide-caption"
        ></div>
      </div>
      <div
        class="swiper-slide"
        style="background-image: url(assets/images/banner-5.webp)"
      >
        <div
          class="swiper-slide-caption header-transparent-slide-caption"
        ></div>
      </div>
      <div
        class="swiper-slide"
        style="background-image: url(assets/images/4.JPG)"
      >
        <div
          class="swiper-slide-caption header-transparent-slide-caption"
        ></div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="home-slider">
  <div class="swiper-container swiper-home-slide">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide" style="background-image: url(assets/images/2.jpg);">
        <div class="swiper-slide-caption header-transparent-slide-caption">
        </div>
      </div> -->
<!-- <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
      </div>
      <div class="swiper-slide" style="background-image: url(assets/images/3.JPG);">
        <div class="swiper-slide-caption header-transparent-slide-caption">
        </div>
      </div>
      <div class="swiper-slide" style="background-image: url(assets/images/banner-5.webp);">
        <div class="swiper-slide-caption header-transparent-slide-caption">
        </div>
      </div>
      <div class="swiper-slide" style="background-image: url(assets/images/4.JPG);">
        <div class="swiper-slide-caption header-transparent-slide-caption">

        </div>
      </div>
    </div>
  </div>
</section> -->
<section class="section-sm counter-sec pb-lg-0 mt-2">
  <div class="container">
    <div
      class="row row-cols-lg-4 gy-3 row-cols-md-4 row-cols-2 gx-lg-4 justify-content-lg-evenly justify-content-between mx-auto"
    >
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0">42<span class="primary-purple h2">+</span></h3>
          <p>
            Years of Innovation<br />
            &amp; Success
          </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0">13</h3>
          <p>
            Educational<br />
            Institutes
          </p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0">4</h3>
          <p>Distinguished Universities</p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0">200 <span class="primary-purple h2">+</span></h3>
          <p>Courses</p>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="counter-box aos-init aos-animate" data-aos="fade-up">
          <h3 class="mb-0 d-inline">
            50000
            <span class="primary-purple h2">+</span>
          </h3>
          <p>Students</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- courses -->
<section class="section-md explore-course-sec">
  <div class="container">
    <div
      class="row g-5 row-cols-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-3 justify-content-between align-items-center"
    >
      <div class="col">
        <div class="sec-title">
          <h2><span>Our Programs</span></h2>
        </div>
      </div>
    </div>
    <div class="bottom-border"></div>
    <div class="row justify-content-between align-items-center">
      <div class="col-auto">
        <div class="sec-subtitle">
          <h4 class="fw-bold">Under Graduate Programs <span>(4)</span></h4>
        </div>
      </div>
    </div>
    <div class="swiper swiper-programs">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="program-card">
            <div class="program-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/programs/cse-2.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="program-details">
              <div class="d-flex align-items-start justify-content-between">
                <div class="sec-thirdtitle w-auto text-start">
                  <h5 class="text-black">Bachelor of Business Administrator</h5>
                </div>
                <div class="share-img w-auto text-end">
                  <a href="#"
                    ><img
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                      alt="Ghrcacsn"
                  /></a>
                </div>
              </div>
              <div class="pro-year w-auto d-lg-flex d-block">
                <div>
                  <i class="fa fa-calendar-o"></i>
                  <span>3 Years</span>
                </div>
                <div>
                  <i class="fa-regular fa-clock ml-5"></i>
                  <span>Full Time</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <a routerLink="/bba-colleges-nagpur" class="cmn-white-button"
                  >Learn More</a
                >
                <a
                  href="https://raisoni.nopaperforms.com/rgi"
                  class="cmn-button"
                  target="_blank"
                  >Apply Now</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="program-card">
            <div class="program-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/programs/data.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="program-details">
              <div class="d-flex align-items-start justify-content-between">
                <div class="sec-thirdtitle w-auto text-start">
                  <h5
                    class="text-black"
                    title="Bachelor of Commerce in Computer Application"
                  >
                    Bachelor of Commerce
                    <span class="d-lg-block d-flex text-dark">in CA</span>
                  </h5>
                </div>
                <div class="share-img w-auto text-end">
                  <a href="#"
                    ><img
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                      alt="Ghrcacsn"
                  /></a>
                </div>
              </div>
              <div class="pro-year w-auto d-lg-flex d-block">
                <div>
                  <i class="fa fa-calendar-o"></i>
                  <span>3 Years</span>
                </div>
                <div>
                  <i class="fa-regular fa-clock ml-5"></i>
                  <span>Full Time</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <a routerLink="/bcca-colleges-nagpur" class="cmn-white-button"
                  >Learn More</a
                >
                <a
                  href="https://raisoni.nopaperforms.com/rgi"
                  class="cmn-button"
                  target="_blank"
                  >Apply Now</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="program-card">
            <div class="program-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/programs/cse.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="program-details">
              <div class="d-flex align-items-start justify-content-between">
                <div class="sec-thirdtitle w-auto text-start">
                  <h5
                    class="text-black"
                    title="Bachelor In Computer Bachelor In Computer Application (BCA)"
                  >
                    Application<span class="d-lg-block d-flex text-dark">
                      (BCA)</span
                    >
                  </h5>
                </div>
                <div class="share-img w-auto text-end">
                  <a href="#"
                    ><img
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                      alt="Ghrcacsn"
                  /></a>
                </div>
              </div>
              <div class="pro-year w-auto d-lg-flex d-block">
                <div>
                  <i class="fa fa-calendar-o"></i>
                  <span>3 Years</span>
                </div>
                <div>
                  <i class="fa-regular fa-clock ml-5"></i>
                  <span>Full Time</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <a
                  routerLink="/bachelor-of-computer-application"
                  class="cmn-white-button"
                  >Learn More</a
                >
                <a
                  href="https://raisoni.nopaperforms.com/rgi"
                  class="cmn-button"
                  target="_blank"
                  >Apply Now</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="program-card">
            <div class="program-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/programs/cse.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="program-details">
              <div class="d-flex align-items-start justify-content-between">
                <div class="sec-thirdtitle w-auto text-start">
                  <h5 class="text-black">
                    B.SC.
                    <span class="d-lg-block d-flex text-dark">Finance</span>
                  </h5>
                </div>
                <div class="share-img w-auto text-end">
                  <a href="#"
                    ><img
                      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                      alt="Ghrcacsn"
                  /></a>
                </div>
              </div>
              <div class="pro-year w-auto d-lg-flex d-block">
                <div>
                  <i class="fa fa-calendar-o"></i>
                  <span>3 Years</span>
                </div>
                <div>
                  <i class="fa-regular fa-clock ml-5"></i>
                  <span>Full Time</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <a routerLink="/bsc-finance" class="cmn-white-button"
                  >Learn More</a
                >
                <a
                  href="https://raisoni.nopaperforms.com/rgi"
                  class="cmn-button"
                  target="_blank"
                  >Apply Now</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</section>

<section class="section-sm event-sec bg-purple-light">
  <div class="container">
    <div class="sec-title text-center">
      <h2><span> Our Events</span></h2>
    </div>
    <div class="swiper swiper-events">
      <div class="swiper-wrapper">
        <!-- <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/sada-gyan-series-1.webp"
                alt="Programs | Ghrcacsn" class="w-100" />
            </div>
            <div class="event-details">
              <h4>Sada Gyan Series </h4>
              <div class="event-date">
                <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn" />
                <span>20 Jan 2026 </span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Installation Ceremony</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>3 Jan 2026 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/toastmaster- fest-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Toast fest, a major event of Toastmasters</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>24 Dec 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Pickleball Inauguration</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>6 Aug 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/miss-nation.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Miss Nation Competition</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>6 Aug 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity-club.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Farewell Party -2025</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>2 May 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Engfinity Club' s Mega Event</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>22 April 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/finfest.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Finfest 2025</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>8 March 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorn.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Creating A Unicorn</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>8 March 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/raisoni-mandi-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Raisoni Mandi</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>5 March 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/gyan-manthan.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>" Gyan Manthan Management fest - Elimination round"</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>5 March 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/setu-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Setu 2025</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>28 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/science-comerce-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Science & Commerce Exhibition</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>22 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/budget.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Budget Analysis competition</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>22 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shiv-jaynti-1.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Shivaji jayanti</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>18 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rotract-club.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Rotract club and Drishtikon</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>16 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mega-event.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Engfinity Club' s Mega Event</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>11 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/guest-lecture.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Guest lecture</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>10 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/vasant-2.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Vasant Panchmi Saraswati Puja</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>1 February 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/toaster.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Toastmasters event</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>11 January 2025 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/development-program.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Student Development Program (GHRSTU), Nagpur</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>19 December 2024 </span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/kite.webp"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Kite Flying Festival</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>14 Junuary 2025</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-15.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>News Analysis</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>4 December 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Deep Milan</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>25 October 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Big Boss</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>25 September 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/engfinity.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Engfinity Club' s Mega Event</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>27 September 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Installation Ceremony</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>9 September 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganeshchaturthi.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Ganesh Chaturthi</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>7 September 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/hackathon.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>"International Hackathon for SIH - 2024"</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>31 August 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-1.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Mission Voting camping</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>31 August 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rakhi-competition.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Rakhi making Competition</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>17 August 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-program.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Installation Program</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>12 August 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/cynosure.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Cynosure</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>2 August 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/induction-program.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Induction program</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>11 July 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/raisoni-mandi.avif"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Raisoni Mandi</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>11 May 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party1.jpg"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Farewell Party</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>18 May 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-ceremony1.jpg"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Farewell Ceremony</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>17 May 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/gyan-manthan.jpg"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Gyan Manthan</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>26 Jan 2024</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="event-card">
            <div class="event-img">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/clubs.jpg"
                alt="Programs | Ghrcacsn"
                class="w-100"
              />
            </div>
            <div class="event-details">
              <h4>Toastmasters Club</h4>
              <div class="event-date">
                <img
                  src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                  alt="Ghrcacsn"
                />
                <span>26 June 2024</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center position-relative mt-4">
      <a routerLink="/events" class="cmn-button text-white p-2"
        >View More Events</a
      >
      <div class="text-center">
        <div class="swiper-button-next event-btn-next"></div>
        <div class="swiper-button-prev event-btn-prev"></div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="section-lg sec-testimonial bg-purple-light">
  <div class="testimonial-overlay"></div>
      <div class="container">
        <div class="sec-title text-center">
          <h2><span>Our Testimonial</span></h2>
      </div>
      <div class="swiper-container swiper-testimonial">
        <div class="swiper-wrapper">
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6 col-sm-6">

                <div class="testi-inner">
                    <h4>Arya Dhakate</h4>
                    <p> GHRCCST </p>
                </div>

              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-2.webp" alt="" class="img-fluid">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src="https://youtu.be/dJUWz-Y5WUA"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href="https://youtu.be/dJUWz-Y5WUA" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="testi-inner">
                      <h4>Piya Kingrani </h4>
                      <p>BBA</p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-3.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery text-center">
                      <li class="video aos-init aos-animate" data-src="https://youtu.be/hscvcrr7rLo"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href="https://youtu.be/hscvcrr7rLo" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6 col-sm-6">
                  <div class="testi-inner">
                    <h4>Khushi Khandelwal's</h4>
                    <p>BBA at GHRCCST. </p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-4.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src="https://youtu.be/AZizDFl5Nxg"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href="https://youtu.be/AZizDFl5Nxg" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6">
                <div class="testi-inner">
                  <h4>Kunjal Sugandh </h4>
                  <p>BCA at GHRCCST. </p>
                </div>
            </div>
              <div class="col-lg-6 col-md-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-5.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src="https://youtu.be/42GjK7jEo-A"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href="https://youtu.be/42GjK7jEo-A" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="../assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6">
                <div class="testi-inner">
                <h4>Kushi Majhitiya's</h4>
                <p> BCA at GHRCCST </p>
              </div>
            </div>
              <div class="col-lg-6 col-md-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-6.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src=" https://youtu.be/LEPPf7RLvVM"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href=" https://youtu.be/LEPPf7RLvVM" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="../assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6">
                <div class="testi-inner">
                  <h4>Sarvesh Shrivastava</h4>
                  <p> BCA at GHRCCST </p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-7.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src=" https://youtu.be/Erf-ubtTW-8"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href=" https://youtu.be/Erf-ubtTW-8" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="../assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide test-inner">
            <div class="row g-0 justify-content-center align-items-center">
              <div class="col-lg-6 col-md-6">
                  <div class="testi-inner">
                  <h4>Vanshika Shrivas</h4>
                  <p> BSC Data Science at GHRCCST </p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="img-area">
                  <div class="overlay-color"></div>
                  <img src="assets/images/testi/testimonial-8.webp" alt="">
                  <div class="lightBox--gallery text-center">
                    <ul id="video-gallery" class="video-gallery">
                      <li class="video aos-init aos-animate" data-src=" https://youtu.be/Ku6wAY4jfNg"
                        data-poster="../assets/images/ghrce-img.webp" >
                        <a href=" https://youtu.be/Ku6wAY4jfNg" class="ripple-effect">
                          <div class="light-gallery-poster">
                            <img src="assets/images/new-theme/play-button.webp" alt="">
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>
</section> -->

<section class="section-lg alumni-sec">
  <div class="container">
    <div class="sec-title m-auto text-center">
      <h2 class="mb-5"><span>Alumni Community</span></h2>
    </div>
    <div class="grid-container">
      <div class="grid-item1">
        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/alumni/Ameya.png);
          "
        >
          <div class="alumni-details">
            <h5>Ameya Dani</h5>
            <p>Oracle Functional Consultant Deloitte Tax LLP</p>
          </div>
        </div>
      </div>
      <div class="grid-item2">
        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/alumni/pranjal.png);
          "
        >
          <div class="alumni-details">
            <h5>Pooja Akhoury</h5>
            <p>
              Radio Compliance Test Engineer at Microsoft, Redmond, Washington,
              United States
            </p>
          </div>
        </div>

        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/alumni/manish.png);
          "
        >
          <div class="alumni-details">
            <h5>Manish Thakur</h5>
            <p>Assistant Manager Godrej & Boyce Mfg. Co. Ltd.</p>
          </div>
        </div>
      </div>
      <div class="grid-item3">
        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/alumni/Yash.png);
          "
        >
          <div class="alumni-details">
            <h5>Yash Agrawal</h5>
            <p>Co-Owner Wisteria Real Vision Pvt. Ltd</p>
          </div>
        </div>
      </div>
      <div class="grid-item4">
        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/community/abhishek.png);
          "
        >
          <div class="alumni-details">
            <h5>Abhishek Rudra</h5>
            <p>
              Applications Engineer at OSI Systems, Torrance, California, United
              States
            </p>
          </div>
        </div>

        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/community/aniruddha.png);
          "
        >
          <div class="alumni-details">
            <h5>Aniruddha Barahate</h5>
            <p>
              Process Engineer at Central California Almond Growers Assn,
              Fresno, California, United States
            </p>
          </div>
        </div>
      </div>
      <div class="grid-item5">
        <div
          class="alumni-card"
          style="
            background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/alumni/Subodh.png);
          "
        >
          <div class="alumni-details">
            <h5>Subodh Joshi</h5>
            <p>Relationship Manager Kotak Mahindra Bank</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-between row-cols-2 mt-4">
      <div class="col-3 text-start position-relative">
        <img
          src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/proudly-raisonian.png"
          alt="proudly raisonian"
        />
      </div>
      <div class="col-8">
        <p>
          Step into the legacy of excellence at Raisoni Education, where your
          journey is empowered, your story is valued, and your achievements make
          you a proud Raisonian.
        </p>
      </div>
    </div>
    <div class="text-center">
      <a
        href="https://alumni.raisoni.net/"
        target="_blank"
        class="cmn-white-button"
        >View More</a
      >
    </div>
  </div>
</section>

<section class="section-sm">
  <div class="container">
    <div class="gradient-separator"></div>
    <div class="section-sm">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-4 col-md-5 col-8 offset-lg-1">
          <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/kimba/kimba.png"
            alt="Kimba | Ghrcacsn"
            class="img-fluid w-100"
          />
        </div>
        <div class="col-lg-4 col-md-7 offset-lg-1 text-lg-start">
          <div class="sec-title">
            <h2>Our <span>Mascot Kimba</span></h2>
            <p class="mb-0">Raisonians! Gear Up,</p>
            <p>Kimba is now on his pawsome adventures!</p>
          </div>

          <a href="kimba" class="cmn-white-button mt-0">Read More</a>
        </div>
      </div>
    </div>
    <div class="gradient-separator"></div>
  </div>
</section>

<section class="section-lg">
  <div class="container">
    <div class="sec-title text-center">
      <h2>Raisoni World <span> #Instagram</span></h2>
    </div>
    <div class="col-12">
      <div class="widget-box">
        <div class="widget-box-inner">
          <iframe
            src="https://www.instagram.com/raisoniworld/embed"
            frameborder="0"
            scrolling="no"
            allowtransparency="true"
          ></iframe>
        </div>
        <div class="text-center">
          <a
            href="https://www.instagram.com/raisoniworld/"
            target="_blank"
            class="cmn-white-button mt-0 mb-3"
            >View Profile</a
          >
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <div class="modal fade show" id="onloadModal" style="padding-right: 17px; display: block;">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body py-3" style="background: #fee9cc;">
             <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true" style="top: -27px;right: -27px; z-index: 1">×</button>
             <div class="" style="position: relative;">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/admission-schedule24-25.jpg" class="img-fluid" title="" alt="" >
          </div>     -->
<!-- <div class="text-center pt-3">
            <a class="button-text " href="https://raisoni.net/photography-competition" target="_blank" ><span>Photography <i class="fa fa-long-arrow-right"></i></span></a>
             <a class="button-text ml-5" href="https://raisoni.net/reel-making-competition" target="_blank" ><span>Reel Making <i class="fa fa-long-arrow-right"></i></span></a>
          </div>               -->
<!-- </div>
        </div>
    </div>
 </div> -->
<!-- <div class="modal fade" id="onloadModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-body py-3" style="background: #fee9cc;">

              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="position: absolute; top: -27px; right: -27px; z-index: 1;"></button>
              <div class="position-relative">
                  <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/admission-schedule24-25.jpg" class="img-fluid" alt="Admission Schedule 24-25">
              </div>
          </div>
      </div>
  </div>
</div> -->

<!-- Modal -->
<!-- <div class="modal fade" id="onloadModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

        <button type="button" class="btn-close cls-btn" data-bs-dismiss="modal" aria-label="Close">X</button>

      <div class="modal-body">
        <div class="banner-sec-main banner-popup">
          <div class="sec-img-2"></div>
          <div class="sec-img-3"></div>
          <div class="container">
              <div class="banner-sm">
                  <div class="row  row-cols-1 row-cols-lg-2 row-cols-md-2 align-items-center justify-content-between">
                      <div class="col-md-6">
                          <div class="banner-heading">
                              <h1>Exclusive
                                  <span class="playfair-display fst-italic">Privileges,
                                  </span> Just for<span class="playfair-display fst-italic">
                                      You!</span>
                              </h1>
                              <p>A special treat this Women's Day! Unlock big savings on top brands
                                  and make every purchase count with Raisoni Privilege.

                              </p>
                          </div>
                          <a href="https://privilege.raisoni.net/login" target="_blank" class="cmn-button cmn-btn">Grab Your Discounts
                              Now</a>
                          <div class="banner-flex my-4 mt-lg-4">
                              <div class="banner-box right-line">
                                  <h4 class="playfair-display fst-italic">Up to 15% off </h4>
                                  <p>on 450+ Brands</p>
                              </div>
                              <div class="banner-box right-line">
                                  <h4 class="playfair-display fst-italic">Hassle-free </h4>
                                  <p>one-tap access to deals</p>
                              </div>
                              <div class="banner-box">
                                  <h4 class="playfair-display fst-italic">Savings </h4>
                                  <p>on your everyday essentials &amp; luxury buys</p>
                              </div>
                          </div>
                      </div>
                      <div class="col">
                          <div class="banner-img d-none d-lg-block">
                              <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/raisoni-privilage/banner-img.png" alt="Programs | Ghrcacsn" class="img-fluid">
                          </div>
                      </div>
                  </div>
                  <div class="brand-logo">
                      <div class="container">
                          <div class="border-gradient bg-white">
                              <div class="row align-items-center">
                                  <div class="col-md-5">
                                      <div class="sec-title mb-0">
                                          <h2 class="mb-0 fs-4">EXPLORE THE <br> MOST-LOVED BRANDS
                                          </h2>
                                      </div>
                                  </div>
                                  <div class="col-md-7">
                                      <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/raisoni-privilage/brands-logo.png" alt="" class="w-100">
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
</div> -->
<app-important-links></app-important-links>
